// extracted by mini-css-extract-plugin
export default {"img":"app-deactivated-page_img__UeH5w","wrapper":"app-deactivated-page_wrapper__Crqv1","title":"app-deactivated-page_title__J5NZU"};